import { Pipe, PipeTransform } from '@angular/core';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';

const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node: any, next: any) => `<p>${next(node.content)}</p>`,
    [INLINES.HYPERLINK]: (node: any) => 
      `<a href="${node.data.uri}" target="_blank">${node.content[0].value}</a>`,
  },
  renderText: (text : string) => text.replace(/\n/g, '<br>'),
};


@Pipe({
  name: 'richText'
})
export class RichTextPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(richText: any): SafeHtml {
    if (!richText) return '';
    
    const html = documentToHtmlString(richText, options);
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
